/* @ngInject */
const contactLabels = () => {
  const self = {}

  self.class = 'Contact'
  self.title = 'Contacts'

  self.fields = {
    id: {
      text: 'Id',
    },
    lastname: {
      text: 'Nom',
    },
    firstname: {
      text: 'Prénom',
    },
    function: {
      text: 'Fonction',
    },
    phones: {
      text: 'Téléphones',
    },
    emails: {
      text: 'Mails',
    },
    email: {
      text: 'E-mail',
    },
    comment: {
      text: 'Commentaire',
    },
  }

  self.statements = {
    add: 'Ajouter un contact',
    index: (_index = 1) => {
      return 'Contact N°' + _index
    },
    create: (_size = 0) => {
      return _size > 1 ? 'Créer de nouveaux contacts' : 'Créer un nouveau contact'
    },
    name: (_size = 0, _point = false) => {
      return 'Contact' + (_size > 1 ? 's' : '') + (_point ? ' : ' : '')
    },
    identity: (_firstname, _lastname) => {
      _firstname = _firstname || ''
      _lastname = _lastname || ''
      return _firstname + ' ' + _lastname
    },
  }

  self.ask = {
    delete: 'Êtes-vous sûr de vouloir supprimer ce contact ?',
  }

  self.log = {
    delete: {
      success: 'Le contact a bien été supprimé.',
      failure: 'Une erreur a interrompu la suppression du contact.',
    },
    search: {
      success: (_length = 0) => {
        if (_length === 0) {
          return 'Aucun contact ne correspond à la recherche.'
        } else if (_length === 1) {
          return '1 contact a été trouvé.'
        } else if (_length > 1) {
          return _length + ' contacts ont été trouvés.'
        }
        return 'Contact recherché.'
      },
      failure: 'Une erreur est survenue durant la recherche des contacts',
      noResult: 'Aucun contact ne correspond à cette recherche',
    },
  }

  return self
}

export default contactLabels



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/contact/resources/labels.resource.js